module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAlklEQVRYhe3TsQ2AIBAF0K+DULGQG2hJ6TSUOoIDURgW0ZhYKXjCBaPxfmm8fw+i+H2qnAtwRg0A2sPjUVvfpXYlAyLLsxEnALGAmxOwDhSWWh7sDgEeTQgwFgSU7P5oyN/QGbVwjqatv9zxyo9QAAIQgAAEIAABvA4wM/rJ2TuAngEgZ0mAtn4C0CTexPZus89K4gGwAuaeHs8aoXu9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_delete_press@2x.png
// module id = 735
// module chunks = 0